import React from "react";
import {Flex} from "../common_style/flex";
import PageCardView, {NewPageCardView} from "components/pages_pane/page_card_view";
import {backgrounds} from "components/tools_pane/tools_items";
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import {Colors, FontStyles} from "components/constants";
import {Span} from "components/common_style/text";
import {Localization} from "localizations/languages";

const SortableItem = SortableElement(({value}) => <li style={{zIndex: 999999, listStyleType: 'none'}}>{value}</li>);

const SortableList = SortableContainer(({items}) => {
    return (
        <ul style={{listStyleType: 'none', margin: 0, padding: 0}}>
            {items.map((value, index) => (
                <SortableItem key={`item-${index}`} index={index} value={value}/>
            ))}
        </ul>
    );
});

function PagesPaneView(props) {
    function _getPage(p, i) {
        if (!p) return null;
        let data = p;
        let bg = !!data ? backgrounds[data.background] : null;
        return <div>
            <Span textStyle={FontStyles.button}
                  style={{marginLeft: 25, marginRight: 25}}>{i === 0 ? Localization.current.translation25 : Localization.current.translation24 + ' ' + i}</Span>
            <PageCardView
                style={{border: i === props.pageN ? 'solid 2px ' + Colors.button : null, marginTop: 7}}
                onClick={() => props.setPage(i)}
                isCover={i === 0}
                onDelete={!!props.deletePage ? () => props.deletePage(i) : null}
                bgImage={!!bg ? bg.thumb : null}
            />
        </div>
    }

    return (
        <Flex column style={{overflowY: 'scroll', height: '100vh', paddingTop: 25}}>
            {_getPage(!!props.pages ? props.pages[0] : null, 0)}
            <SortableList distance={10} lockAxis={'y'}
                          items={!!props.pages ? props.pages.slice(1).map((e, i) => _getPage(e, i + 1)) : []}
                          onSortEnd={props.reorderPages}/>
            {!!props.addPage ? <NewPageCardView
                onClick={props.addPage}
            /> : null}
        </Flex>
    );
}

export default PagesPaneView;
